import { Button, GridLegacy as Grid, Typography } from '@mui/material'
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "@hookform/resolvers/yup";
import React from "react";





const FilterForm =  React.forwardRef(({
  nameFilter='Buscar por',
  inputsFilter=[],
  initialValuesFilter={},
  schemaValidator={},
  onApplyFilter=()=>{},
  hideButtoms=false,
  buttomDist={
    sx:4,
    md:4
  }

}, ref = null) =>{

  const { control,register, handleSubmit, formState:{ errors } } = useForm({
    resolver: yupResolver(schemaValidator),
    defaultValues:initialValuesFilter
  });

  const onSumitData = (values)=>{
      
        onApplyFilter(values);
  }


return (
   <form 
    ref={ref}
   onSubmit={handleSubmit(onSumitData)}
   style={{width:'100%'}} >
        <Grid container spacing={2} alignItems="flex-end">
        <Grid item xs={12} md={12}>
        <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>{nameFilter}</Typography>
        </Grid>
      
          {
            inputsFilter.map( In_filter=><Grid item key={In_filter.keyValue} {...In_filter.grid} >
                  <Controller 
                        control={control}
                        name={In_filter.keyValue}
                        render={ ({field})=>{
                            field.value = !!In_filter.format? In_filter.format(field.value) : field.value; 
                          return <In_filter.InputComponent
                          keyValue={In_filter.keyValue}
                          {...In_filter.InputComponentProps}
                          {...In_filter}
                          {...field}
                          />
                        }} />
                  
            </Grid> )
          }  
          <Grid item display="flex" alignItems="flex-end" sx={4} md={3}
          {
            ...buttomDist
          }
          >
           {!hideButtoms &&  <Button size="small" type="submit" variant="contained" sx={{ minHeight: 40 }} >Aplicar filtro</Button>} 
          
          </Grid>
     
        </Grid>
       
   </form>
)

});

export {
  FilterForm
}